import { render, staticRenderFns } from "./sokum.vue?vue&type=template&id=8f371d20&"
import script from "./sokum.vue?vue&type=script&lang=js&"
export * from "./sokum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports